import React from 'react';
import { CircleTopicFormat } from '@modernhealth/circles-graphql';
import { formatCircleFormat } from '@modernhealth/circles-web-components';
import { useTranslation } from 'react-i18next';

function translationKey(format: CircleTopicFormat) {
    switch (format) {
        case CircleTopicFormat.Discussion:
            return 'shared.format.discussion';
        case CircleTopicFormat.Fireside:
            return 'shared.format.fireside_chat';
        case CircleTopicFormat.ListenAndLearn:
            return 'shared.format.listen_and_learn';
        case CircleTopicFormat.Workshop:
            return 'shared.format.workshop';
        default:
            return '';
    }
}

export const TranslatedCircleFormat = ({ format }: { format: CircleTopicFormat }) => {
    const { t } = useTranslation('circles');

    if (format === CircleTopicFormat.Fireside) {
        return (
            <>
                {t(['shared.format.discussion', 'Fireside Chat'], {
                    ignoreJSONStructure: true,
                })}
            </>
        );
    }

    const tKey = translationKey(format);

    // t("Listen and Learn")
    // t("Discussion")
    // t("Workshop")
    return (
        <>
            {t([formatCircleFormat(format), tKey], {
                /* Our "keys" have spaces in them, so look them up directly.*/
                ignoreJSONStructure: true,
            })}
        </>
    );
};
